var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.202 3.774A1.445 1.445 0 0 1 8.49 3h3.02c.546 0 1.044.3 1.288.774l.691 1.345a.396.396 0 0 0 .352.214H15.6c1.325 0 2.4 1.045 2.4 2.334v7C18 15.955 16.925 17 15.6 17H4.4C3.075 17 2 15.955 2 14.667v-7c0-1.289 1.075-2.334 2.4-2.334h1.758a.396.396 0 0 0 .352-.214l.692-1.345zM7.792 11a2.208 2.208 0 1 1 4.416 0 2.208 2.208 0 0 1-4.416 0zM10 7.208a3.792 3.792 0 1 0 0 7.584 3.792 3.792 0 0 0 0-7.584z",
    fill: "#BE69C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon_photo.1ef5464a65aa9fed65bab54cee91ea82.svg";
export { ForwardRef as ReactComponent };